import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  categoryName: {
    font: {
      size: '1.6rem',
      lineHeight: '2.4rem',
      weight: 500,
    },
    color: colors.neutral[900],
    margin: [0],
    marginBottom: '0.4rem',
    textTransform: 'uppercase',
  },
  categoryWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: colors.neutral[700],
    borderBottom: '0.1rem solid #C1C7CD',
  },
  notesText: {
    whiteSpace: 'pre-line',
    font: {
      size: '1.4rem',
      lineHeight: '2.0rem',
      weight: 400,
    },
    margin: {
      bottom: '4rem',
    },
    paddingTop: '2.4rem',
    color: colors.neutral[700],
  },
  editNotes: {
    marginRight: '-3rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
